import { useEffect, useState } from 'react';
import { FTS0015_GROUP_PARAMETER_KEY, FTS0015_GROUP_PARAMETER_OPTIONS, FTS0015_TREATMENT_KEY, PARAMETERS } from '../constants/ExperimentKeys';
import { laboratoryClient } from '../utils/laboratoryUtil';
export const logFTS0015Exposure = () => {
  laboratoryClient.logExposure(FTS0015_TREATMENT_KEY);
};

// https://tools.hubteam.com/laboratory/experiments/edit/fts-0015?tab=workflow&step=0
export const useIsFTS0015Variant = isEligibleForFTS0015 => {
  const [isFTS0015Variant, setIsFTS0015Variant] = useState(false);
  const [isFTS0015Fetched, setIsFTS0015Fetched] = useState(false);
  useEffect(() => {
    if (isEligibleForFTS0015) {
      if (!isFTS0015Fetched) {
        laboratoryClient.resolve(treatments => {
          if (Object.keys(treatments).length) {
            const treatment = treatments[FTS0015_TREATMENT_KEY];
            const cohort = treatment[PARAMETERS][FTS0015_GROUP_PARAMETER_KEY];
            const isVariant = cohort === FTS0015_GROUP_PARAMETER_OPTIONS.variant;
            setIsFTS0015Variant(isVariant);
          }
          setIsFTS0015Fetched(true);
          logFTS0015Exposure();
        });
      }
    }
  }, [isFTS0015Fetched, isEligibleForFTS0015]);
  return {
    isFTS0015Variant,
    isFTS0015Fetched
  };
};